import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import Icon from "./nounproject-ui-icon";
import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginMenu extends React.Component {
    closeMenu(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    logOut(e) {
        e.preventDefault();
        this.props.logOut(`/plugin/${this.props.host}/#/search/`);
    }

    render() {
        let billing,
            customerServiceURl = "/help/plug-ins/",
            userSettings;

        if (this.props.host === "office") {
            customerServiceURl = "/help/office365-add-in/";
        }
        if (this.props.host === "adobe") {
            customerServiceURl = "/help/adobe-add-on/";
        }

        if (this.props.currentUser) {
            if (this.props.currentUser.has_premium_account) {
                billing = (
                    <li>
                        <a
                            href="/settings/billing/"
                            target="_blank"
                            className="plugin-settings-menu-item"
                            onClick={window.handleLink.bind(this)}
                        >
                            Billing
                        </a>
                    </li>
                );
            }

            userSettings = (
                <li>
                    <a
                        href={`/${this.props.currentUser
                            .username}/settings/basics/`}
                        className="plugin-settings-menu-item"
                        target="_blank"
                        onClick={window.handleLink.bind(this)}
                    >
                        Settings
                    </a>
                </li>
            );
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="plugin-menu"
                    style={{
                        background: "#000000",
                        color: "#FFFFFF",
                        padding: "50px 16px 16px",
                        minHeight: "100%",
                        textAlign: "center"
                    }}
                >
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeMenu.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>

                    <ul className="plugin-settings-menu-list">
                        {userSettings}
                        {billing}
                        <li>
                            <a
                                href={customerServiceURl}
                                target="_blank"
                                className="plugin-settings-menu-item"
                                onClick={window.handleLink.bind(this)}
                            >
                                Customer Support
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                className="plugin-settings-menu-item"
                                onClick={this.logOut.bind(this)}
                            >
                                Logout
                            </a>
                        </li>
                    </ul>
                </div>

                <PluginFooter />
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host,
        currentUser;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return { host, currentUser };
}

module.exports = connect(mapStateToProps, {
    logOut: actions.logOut
})(PluginMenu);
